import { z } from "zod";
import { LogStreamEventSchema } from "../schemas/logStreamEvent.schema";

export enum EventType {
    LOGIN_SUCCESS = "LOGIN_SUCCESS",
    LOGIN_FAILED = "LOGIN_FAILED",
    LOGOUT_SUCCESS = "LOGOUT_SUCCESS",
    LOGOUT_FAILED = "LOGOUT_FAILED",
}

export enum EventConnection {
    SMS = "SMS",
    EMAIL = "EMAIL",
}

export type LogStreamEvent = z.infer<typeof LogStreamEventSchema>;
